export class QuestionsCountModel {
    totalQnsCount: number;
    lastMonthAddedQnsCount: number;
    lastWeekAddedCount: number;
    activeQuestions: number;
    inActiveQuestions: number;
    constructor(
        totalQnsCount: number,
        lastMonthAddedQnsCount: number,
        lastWeekAddedCount: number,
        activeQuestions: number,
        inActiveQuestions: number
    ) {
        this.totalQnsCount = totalQnsCount;
        this.lastMonthAddedQnsCount = lastMonthAddedQnsCount;
        this.lastWeekAddedCount = lastWeekAddedCount;
        this.activeQuestions = activeQuestions;
        this.inActiveQuestions = inActiveQuestions;
    }
}